import React, { Suspense } from "react";
import { connect } from "react-redux";

import { AuthLayout, Header, Phone } from "./LazyLoadedPages";

import TaskForm from "#app/pages/Relations/Tasks/form/TaskForm";
import { setTaskForm, setTaskModalVisible, setTaskType } from "#app/store/actions/task";
import BlockSkeleton from "#app/components/common/BlockSkeleton";

interface CabinetLayoutStateProps {
    modalVisible?: boolean;
    taskForm?: unknown;
    taskType?: unknown;
    auth?: unknown;
}

interface CabinetLayoutDispatchProps {
    setTaskModalVisible: (visible: boolean) => void;
    setTaskType: (type: unknown) => void;
    setTaskForm: (form: unknown) => void;
}

type CabinetLayoutProps = CabinetLayoutStateProps & CabinetLayoutDispatchProps;

const CabinetLayout: React.FC<CabinetLayoutProps> = ({
    modalVisible,
    setTaskModalVisible,
    taskForm,
    taskType,
    setTaskType,
    setTaskForm,
    auth,
}) => (
    <Suspense fallback={<BlockSkeleton lines={4} />}>
        <Header />
        <AuthLayout />
        <Phone />
        <TaskForm
            setModalVisible={setTaskModalVisible}
            modalVisible={modalVisible}
            form={taskForm}
            taskType={taskType}
            setTaskType={setTaskType}
            setForm={setTaskForm}
            callback={() => {}}
            auth={auth}
        />
    </Suspense>
);

const enhance = connect(
    (state: {
        task: { modalVisible?: boolean; form?: unknown; type?: unknown };
        auth: unknown;
    }) => ({
        modalVisible: state.task.modalVisible,
        taskForm: state.task.form,
        taskType: state.task.type,
        auth: state.auth,
    }),
    { setTaskModalVisible, setTaskForm, setTaskType }
);

export default enhance(CabinetLayout);
